import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { tokens, Tag, Button, Modal, Loader } from '@hotjar/hotsauce';
import { PlanTrafficCoverageLabel } from '../Upsell/components/PlanTrafficCoverageLabel/PlanTrafficCoverageLabel';

export const PlanColumnStyles = {
  PlanContainer: styled.div<{ isHighlighted: boolean; isTrafficRecommendationModal?: boolean }>`
    background: ${tokens.color.white};
    border-radius: ${tokens.radius.l};
    border: 1px solid transparent;
    flex: 1;
    padding: ${(props) =>
      props.isTrafficRecommendationModal
        ? `${tokens.spacer.x3} ${tokens.spacer.x2}`
        : `${tokens.spacer.x3} ${tokens.spacer.x2pt5}`};
    position: relative;

    ${(props) => {
      const borderColor = props.isTrafficRecommendationModal
        ? tokens.color.ui_border
        : tokens.color.ui_border_light;

      const highlightedBorderColor = props.isTrafficRecommendationModal
        ? tokens.BRAND_COLORS.cobalt_300
        : tokens.BRAND_COLORS.cobalt_200;

      return props.isHighlighted
        ? css`
            background: ${tokens.color.bg_active};
            border-color: ${highlightedBorderColor};
          `
        : css`
            border-color: ${borderColor};
          `;
    }}
  `,
  RecommendedTag: styled(Tag)`
    background: ${tokens.BRAND_COLORS.midnight_600};
    color: ${tokens.color.text_default_inverse};
    position: absolute;
    right: ${tokens.spacer.x2pt5};
    text-transform: uppercase;
    top: 0;
    transform: translateY(-50%);

    ${tokens.text('caption')};
  `,
  Title: styled.div<{ isAnnualPricingShown: boolean }>`
    display: flex;
    justify-content: space-between;
    height: ${(props) => (props.isAnnualPricingShown ? tokens.spacer.x5pt5 : tokens.spacer.x3pt5)};
    align-items: flex-start;
  `,
  FeatureGroup: styled.div`
    ${tokens.text('header5')};
    text-transform: capitalize;
  `,
  PlanSubTitle: styled.div<{ isAnnualPricingShown: boolean }>`
    ${tokens.text('body1')};

    color: ${tokens.color.text_light};
    margin: ${(props) => (props.isAnnualPricingShown ? tokens.spacer.x2 : tokens.spacer.x1)} 0
      ${tokens.spacer.x3} 0;
    white-space: pre-line;
  `,
  AllowanceContainer: styled.div<{ isTrafficRecommendationModal?: boolean }>`
    ${tokens.text('body2')};

    align-items: center;
    display: flex;
    flex-direction: row;
    height: 60px;
    justify-content: flex-start;

    ${(props) =>
      props.isTrafficRecommendationModal &&
      css`
        ${tokens.text('body1')};
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 80px;
        text-align: center;
        margin: ${tokens.spacer.x3pt5} 0 0 0;
      `}
  `,
  PlanTrafficCoverageLabel: styled(PlanTrafficCoverageLabel)<{ withSkuDropdown?: boolean }>`
    margin-top: ${(props) => (props.withSkuDropdown ? tokens.spacer.x0pt5 : tokens.spacer.x1)};
    justify-content: ${(props) => (props.withSkuDropdown ? 'center' : 'left')};
    text-align: center;
  `,
  PlanUpgrade: styled.div`
    display: flex;
    flex-flow: column;
  `,
  StyledButton: styled(Button)<{ isTrafficRecommendationModal?: boolean }>`
    justify-content: center;

    ${(props) =>
      props.isTrafficRecommendationModal &&
      css`
        height: ${tokens.spacer.x5};
        max-height: ${tokens.spacer.x5};
      `}
  `,
  PlanSelectorLabel: styled.div<{ isTrafficRecommendationModal?: boolean }>`
    ${tokens.text('caption')};

    color: ${tokens.color.text_light};
    margin-bottom: ${tokens.spacer.x0};
    text-transform: uppercase;

    ${(props) =>
      props.isTrafficRecommendationModal &&
      css`
        margin: ${tokens.spacer.x3pt5} 0 ${tokens.spacer.x0pt5} 0;
        text-align: center;
        text-transform: none;
      `}
  `,
  NotAvailable: styled.div<{ isTrafficRecommendationModal?: boolean }>`
    ${tokens.text('subtitle2')};
    padding: ${(props) =>
      props.isTrafficRecommendationModal ? `10px 0` : `${tokens.spacer.x1pt5} 0`};
    display: flex;
    justify-content: center;
  `,
};

export const PlanColumnsStyles = {
  FindOutMore: styled.div<{ isTrafficRecommendationModal?: boolean }>`
    padding: ${(props) =>
      props.isTrafficRecommendationModal
        ? `${tokens.spacer.x2} 0 0 ${tokens.spacer.x2}`
        : `0 0 0 ${tokens.spacer.x2}`};
  `,
};

export const ModalStyles = {
  Modal: styled(Modal)`
    margin: ${tokens.spacer.x6} auto;
    max-height: calc(100vh - ${tokens.spacer.x6} * 2);
    width: 1136px;
  `,
  ModalHeader: styled(Modal.Header)`
    border-bottom: 1px solid ${tokens.color.ui_border_light};
  `,
  ModalBody: styled(Modal.Body)`
    background: ${tokens.BRAND_COLORS.white};
    padding-top: ${tokens.spacer.x4pt5};
  `,
  Loader: styled(Loader)`
    flex: 1 1 auto;
  `,
};
